<template>
  <div class="checkout-success-container wrapper">
    <div class="success-img">
      <img src="@/assets/img/comet/live/fkcg@2x.png" alt="">
    </div>
    <div class="success-title">Congratulations! </div>
    <div class="success-subtitle">You have get the course successfully!</div>
    <p class="success-text">To see this course you just bought as well as courses your purchased, please visit the page "My Courses".</p>
    <p class="success-text">Also you can see live or replay of each course on that page.</p>
    <div class="success-btn-box">
      <ct-button @click="$router.push({name: 'userCourses'})" type="primary" size="medium" round> See My Courses</ct-button>
    </div>
  </div>
</template>

<script>
import api from '../../api'
import { orderState } from '@ca/constants'
export default {
  name: 'PaySuccess',
  data () {
    return {
      order_state: undefined
    }
  },
  mounted () {
    setTimeout(() => {
      api.queryOrder({
        params: {
          order_no: this.order_no,
          keep_alive: 0
        }
      }).then(res => {
        let data = res.data
        if (data && data.code === 1) {
          if (data.data.state === orderState['SUCCESS_PAY']) {
            this.order_state = 'success'
          } else {
            this.order_state = 'faild'
          }
        } else {
          this.order_state = 'faild'
        }
      }, err => {
        this.order_state = 'faild'
        console.log(err)
      })
    }, 2000)
  },
  computed: {
    order_no () {
      return this.$route.query.order_no
    }
  },
  watch: {
    order_state (val) {
      if (val === 'faild') {
        this.$toast({
          type: 'error',
          message: 'Oops, something went wrong or this order has become invalid. Please go back to restart the process.'
        })
        setTimeout(() => {
          this.$router.push({
            name: 'live'
          })
        }, 2000)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .checkout-success-container {
    padding-top: 80px;
    text-align: center;
    color:rgba(26,61,94,1);
    .success-img {
      margin-bottom: 56px;
      img {
        width: 219px;
        max-width: 100%;
      }
    }
    .success-title {
      font-size:28px;
      font-weight:500;
      line-height:28px;
      margin-bottom: 16px;
    }
    .success-subtitle {
      font-size:20px;
      font-weight:500;
      line-height:20px;
      margin-bottom: 32px;
    }
    .success-text {
      font-size:14px;
      font-weight:400;
      color:rgba(54,85,114,1);
      line-height:20px;
    }
    .success-btn-box {
      margin-top: 64px;
    }
  }
</style>
